export { default, type OwnProps as SwitchProps } from './Switch';
